import i18n from "@/i18n";

export interface NoticeTypeIcon {
  icon: string;
  colour: string;
}
export interface NoticeType {
  text: string;
  value: string;
  colour: string;
  icon: NoticeTypeIcon | null;
}
export default class Notice {
  noticeId!: number;
  restaurantId?: number;
  date!: string;
  message!: string;
  type!: string;

  constructor(jsonObj?: Notice) {
    if (jsonObj) {
      Notice.updateNotice(this, jsonObj);
    }
  }

  static updateNotice(toUpdate: Notice, newVals: Notice) {
    toUpdate.noticeId = newVals.noticeId;
    toUpdate.restaurantId = newVals.restaurantId;
    toUpdate.date = newVals.date;
    toUpdate.message = newVals.message;
    toUpdate.type = newVals.type;
  }

  static copy(notice: Notice): Notice {
    return new Notice(JSON.parse(JSON.stringify(notice)));
  }

  static haveDifferences(n1: Notice, n2: Notice): boolean {
    return !(JSON.stringify(n1) === JSON.stringify(n2));
  }

  static getNoticeTypeFromString(status: string): NoticeType | null {
    for (let i = 0; i < Notice.noticeTypes.length; i++)
      if (status === Notice.noticeTypes[i].value) return Notice.noticeTypes[i];
    return null;
  }

  static noticeTypes: NoticeType[] = [
    {
      text: i18n.tc("restaurant.notice.type.full-online"),
      value: "FULL_ONLINE",
      colour: "green",
      icon: { icon: "mdi-lock", colour: "green" }
    },
    {
      text: i18n.tc("restaurant.notice.type.full"),
      value: "FULL",
      colour: "red",
      icon: { icon: "mdi-lock", colour: "red" }
    },
    {
      text: i18n.tc("restaurant.notice.type.warning"),
      value: "WARNING",
      colour: "orange",
      icon: { icon: "mdi-alert", colour: "orange" }
    },
    {
      text: i18n.tc("restaurant.notice.type.private-event"),
      value: "PRIVATE_EVENT",
      colour: "orange",
      icon: { icon: "mdi-party-popper", colour: "orange" }
    }
  ];
}
